import { Injectable } from "@angular/core";
import { AbstractControl, ValidationErrors } from "@angular/forms";

/**
 * Classe centralizadora de validadores customizados e utilitários para exibição de mensagens
 * de erro em formulários reativos do Angular.
 */
@Injectable({
  providedIn: "root"
})
export class CustomValidatorsService {

    notBlankValidator(control: AbstractControl): ValidationErrors | null {
        const value = control.value;
        if (typeof value === "string" && value.trim().length === 0) {
            return { required: true };
        }
        return null;
    }
}
